import { memo } from 'react';

import { usePosts } from '../hooks/usePosts';

const ShowNewPosts = () => {
  const { newPosts, showAddedPosts } = usePosts();
  if (!newPosts.length) return null;

  return (
    <button type='button' onClick={showAddedPosts}>
      {newPosts.length} NEW POSTS!
    </button>
  );
};

export default memo(ShowNewPosts);
